import { useState } from 'react'

import * as S from './OptionSelector.styles'

const OptionSelector = ({ options = [], label = '', fnSelectedOption, initialState = "" }) => {
  const [selectedOption, setSelectedOption] = useState(initialState)

  const handleSelectOption = (option = '') => {
    fnSelectedOption?.(option)
    setSelectedOption(option)
  }

  return (
    <S.OptionSelectorWrapper>
      {label && (
        <S.OptionLabel>{label}</S.OptionLabel>
      )}

      <S.OptionsContainer>
        {options.map((option) => {
          return (
            <S.OptionSelectorOption selected={selectedOption === option} onClick={() => handleSelectOption(option)} key={option}>
              {option}
            </S.OptionSelectorOption>
          )
        })}
      </S.OptionsContainer>

    </S.OptionSelectorWrapper>
  )
}

export default OptionSelector